export interface IPersistenceService {
    getProvider: () => string | null;
    saveProvider: (provider: string) => void;
    saveCurrentObjectId: (id: string) => void;
    getCurrentObjectId: () => string | null;
    saveLogoutTriggeredFromPortal: (value: boolean) => void;
    getLogoutTriggeredFromPortal: () => boolean | null;
    clearNonPersistentItems: () => void;
    setSelectedCustomerId: (id: string) => void;
    getSelectedCustomerId: () => string | null;
    getTranslations: () => string | null;
    setTranslations: (value: string) => void;
    getCollapsed: () => boolean | null;
    setCollapsed: (value: boolean) => void;
    setSelectedTimeZone: (value: string) => void;
    getSelectedTimeZone: () => string | null;
    getCourseFilter: () => string | null;
    setCourseFilter: (value: string) => void;
    setLanguage: (value: string) => void;
    getLanguage: () => string | null;
    setSelectedCourseLanguages: (value: string) => void;
    getSelectedCourseLanguages: () => string | null;
    setSelectedCourseLevels: (value: string) => void;
    getSelectedCourseLevels: () => string | null;
    setSelectedUserCourseLevels: (value: string) => void;
    getSelectedUserCourseLevels: () => string | null;
    setSelectedCourseTrainings: (value: string) => void;
    getSelectedCourseTrainings: () => string | null;
    setSelectedRole: (value: string) => void;
    getSelectedRole: () => string | null;
    setEducationSelectedRole: (value: string) => void;
    getEducationSelectedRole: () => string | null;
    getIsMobileApp: () => boolean | null;
    setIsMobileApp: (value: boolean) => void;
    getShowNonZero: () => boolean | null;
    setShowNonZero: (value: boolean) => void;
    setLoginFirstRedirectHasBeenMade?: (value: boolean) => void;
    getLoginFirstRedirectHasBeenMade?: () => boolean;
    setOnboaringFlowCurrentStep: (onboardingFlowId: number, step: number) => void;
    getOnboaringFlowCurrentStep: (onboardingFlowId: number) => number | null;
}

export enum LocalStorageKeys {
    SelectedCustomerId = 'selectedCustomerId',
    CurrentObjectId = 'currentObjectId',
    Language = 'lang',
    Translations = 'translations',
    SelectedTimeZone = 'selectedTimeZone',
    LogoutTriggeredFromPortal = 'logoutTriggeredFromPortal',
    SelectedCourseLanguages = 'selectedCourseLanguages',
    SelectedCourseLevels = 'selectedCourseLevels',
    SelectedUserCourseLevels = 'selectedUserCourseLevels',
    SelectedCourseTrainings = 'selectedCourseTrainings',
    CourseFilter = 'courseFilter',
    LoginFirstRedirectHasBeenMade = 'loginFirstRedirectHasBeenMade',
	Collapsed = 'collapsed',
	SelectedRole = 'selectedRole',
	EducationSelectedRole = 'educationSelectedRole',
	IsMobileApp = 'isMobileApp',
	ShowNonZero = 'showNonZero'
}

let PersistenceType = {
    IPersistenceService: Symbol('IPersistenceService'),
};

export default PersistenceType;